import envConfig from '@nile/home/src/Config/env';
import { BrandingLogo, BackgroundIcon } from '@nile/components';
import React from 'react';
import styled from 'styled-components';
import { FormattedMessage } from 'react-intl';

const ModalWrapperParent = styled.div`
  background-image: ${(props) =>
    props.idpFlow ? 'none' : `url(${envConfig.imageRoot}svg/chatBg.svg)`};
  background: ${(props) =>
    props.idpFlow
      ? 'linear-gradient(180deg,rgba(218, 187, 243, 0) 4.2%,rgba(218, 187, 243, 0.5) 48.27%,rgba(218, 187, 243, 0) 100%)'
      : 'none'};
  height: 100vh;
  overflow: auto;
  .card-parent {
    width: 600px;
    background: #ffffff;
    box-shadow: 0px 2px 12px 8px rgba(0, 0, 0, 0.0756665);
    border-radius: 12px;
    padding: 40px;
  }

  .card-component-title {
    font-size: 24px;
    color: rgba(0, 0, 0, 0.85);
    font-weight: 500;
  }
  input,
  input:focus {
    height: 38px;
    padding: 8px 16px;
  }

  .login-card {
    min-height: 515px;
    position: relative;
  }

  .tfa-code {
    width: 925px !important;
  }
`;

export default function ModalWrapper(props) {
  function getCardClasses() {
    let classes = 'card-parent fx col';
    if (props.loginPage && !props?.idpFlow) {
      classes += ' login-card';
    }

    if (props?.idpFlow) {
      classes += ' idp-flow position-relative';
    }

    if (props?.title?.includes('Two Factor Authentication')) {
      classes += ' tfa-code';
    }
    return classes;
  }

  return (
    <ModalWrapperParent
      className={`flex-center ${props?.idpFlow ? 'fcol' : ''}`}
      idpFlow={props?.idpFlow}
    >
      <div className={getCardClasses()}>
        {props?.idpFlow && (
          <div className="position-absolute sparkle-nile">
            <BackgroundIcon
              url={`url(${envConfig.imageRoot}svg/loginsparkle.svg)`}
              alt="Sparkle"
              width="50px"
              height="50px"
            />
          </div>
        )}

        <BrandingLogo enableFavIconBrand />
        {props?.title && (
          <div className="card-component-title mb40">
            <FormattedMessage id={props?.title} />
          </div>
        )}
        <div>{props?.container}</div>
      </div>
      {props?.idpFlow && <div className="mt20">{props?.footer}</div>}
    </ModalWrapperParent>
  );
}
